import { UserQuestionData } from "../types/MessageData";
import { FeedbackDetail, FeedbackReason } from "../types/Feedback";

/* TODO: Im Deployment muss sichergestellt werden, dass die Typescript-Daten nicht mitgehen. In der deployten Version kann aktuell der gesamte Source-Code analysiert werden. */


const warmupBackend = async (): Promise<boolean> => {
    const options : RequestInit = { 
        method: 'post',
        headers: { 'Content-Type': 'application/json' }
    };
    const httpResponse = await fetch(`/api/Warmup`, options);
    if (!httpResponse.ok) {
        const responseBody = await httpResponse.text();
        throw new Error(responseBody);
    }
    return httpResponse.ok;
}
const postMessage = async (serializedChatHistory: string, message: UserQuestionData, expectedResponseMessageId: string, contextRetrievalMode: string): Promise<ReadableStream<Uint8Array> | null> => {
    const options : RequestInit = { 
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ asStream: true, message, serializedChatHistory, expectedResponseMessageId, contextRetrievalMode})
    };
    const httpResponse = await fetch(`/api/Message`, options)
    if (!httpResponse.ok) {
        console.error(httpResponse);
        throw new Error("Es ist ein Fehler aufgetreten!")
    }
    return httpResponse.body;
} 

const postFeedback = async(messageId: string, serializedChatHistory: string, details: FeedbackDetail): Promise<boolean> => {
    const options : RequestInit = { 
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messageId, serializedChatHistory, details})
    };
    const httpResponse = await fetch(`/api/Feedback`, options);
    if (!httpResponse.ok) {
        const responseBody = await httpResponse.text();
        throw new Error(responseBody);
    }
    return httpResponse.ok;
}

const loadFeedbackFormData = async(): Promise<{ reasons: FeedbackReason[]}> => {
    const options : RequestInit = { 
        method: 'post',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    };
    const httpResponse = await fetch(`/api/FeedbackFormData`, options);
    if (!httpResponse.ok) {
        const responseBody = await httpResponse.text();
        throw new Error(responseBody);
    }
    const result: { reasons: FeedbackReason[]} = await httpResponse.json();
    return result;
}

const trackEvent = async(eventName: string, clientId: string, properties: {[key: string]: string | number}): Promise<void> => {
    const body = { eventName, clientId, properties};
    console.log("track event", body);
    const options : RequestInit = { 
        method: 'post',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
    };
    const httpResponse = await fetch(`/api/TrackEvent`, options);
    if (!httpResponse.ok) {
        const responseBody = await httpResponse.text();
        throw new Error(responseBody);
    }
}

export const backendProxy = {
    postMessage, 
    postFeedback, 
    loadFeedbackFormData,
    warmupBackend,
    trackEvent
}